import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, Shield, Gift, Clock, ChevronDown, ChevronUp } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const bonusDetails = [{
  number: '01',
  title: 'Checklist Anti-Humedad (12 puntos)',
  subtitle: 'Mil Hojas A Prueba de Clima',
  promise: 'Tu control de calidad en 5 minutos para evitar el hojaldre "chicloso".',
  bullets: ['12 checks antes/durante/después', 'Versión imprimible + versión móvil', 'Tarjeta de emergencia (rescates rápidos)'],
  value: '$9'
}, {
  number: '02',
  title: 'Guía "Corte Limpio"',
  subtitle: 'Herramientas + Técnica + Porciones Perfectas',
  promise: 'Porciones prolijas sin aplastar capas ni embarrar crema.',
  bullets: ['Técnica Corta–Guía–Limpia', 'Checklist pre-corte', 'Tabla de porciones (6/8/10/12)'],
  value: '$11'
}, {
  number: '03',
  title: 'Kit Solución de Problemas',
  subtitle: 'Diagnóstico Rápido (16 fallas + fixes)',
  promise: 'Identifica la falla y aplica el fix correcto en minutos.',
  bullets: ['Tabla síntoma → causa → fix', 'Árbol de decisión rápido', 'Checklist prevención (7 puntos)'],
  value: '$17'
}];
export function OfferSection() {
  const [showBonusDetail, setShowBonusDetail] = useState(false);
  return <Section background="cream" className="pb-24" id="oferta" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-100" data-id="element-140">
          <div className="bg-stone-900 p-6 text-center" data-id="element-141">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-142">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="text-amber-400 mt-2 font-medium" data-id="element-143">
              Domina la técnica hoy mismo
            </p>
          </div>

          <div className="p-8 md:p-12 grid md:grid-cols-2 gap-12 items-start" data-id="element-144">
            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100" data-id="element-145">
              <div className="flex items-center justify-between mb-4" data-id="element-146">
                <h3 className="font-bold text-stone-900 flex items-center gap-2" data-id="element-147">
                  <Gift className="w-5 h-5 text-amber-600" data-id="element-148" />
                  Bonos incluidos hoy
                </h3>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-700 bg-amber-100 border border-amber-200 px-2 py-0.5 rounded-full" data-id="element-149">
                  <Clock className="w-3 h-3" data-id="element-150" />
                  Solo hoy
                </span>
              </div>

              <div className="space-y-3 mb-4" data-id="element-151">
                <div className="bg-white rounded-lg p-3 border border-stone-200" data-id="element-152">
                  <div className="flex items-start justify-between gap-2" data-id="element-153">
                    <div data-id="element-154">
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-0.5" data-id="element-155">
                        Bono 01
                      </p>
                      <p className="text-sm font-semibold text-stone-900 leading-snug" data-id="element-156">
                        Checklist Anti-Humedad (12 puntos)
                      </p>
                      <p className="text-xs text-stone-500 mt-1" data-id="element-157">
                        Tu control de calidad en 5 min para evitar el hojaldre
                        "chicloso".
                      </p>
                    </div>
                    <span className="text-xs font-bold text-stone-400 line-through whitespace-nowrap flex-shrink-0" data-id="element-158">
                      $9
                    </span>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-3 border border-stone-200" data-id="element-159">
                  <div className="flex items-start justify-between gap-2" data-id="element-160">
                    <div data-id="element-161">
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-0.5" data-id="element-162">
                        Bono 02
                      </p>
                      <p className="text-sm font-semibold text-stone-900 leading-snug" data-id="element-163">
                        Guía "Corte Limpio"
                      </p>
                      <p className="text-xs text-stone-500 mt-1" data-id="element-164">
                        Porciones prolijas sin aplastar capas ni embarrar crema.
                      </p>
                    </div>
                    <span className="text-xs font-bold text-stone-400 line-through whitespace-nowrap flex-shrink-0" data-id="element-165">
                      $11
                    </span>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-3 border border-stone-200" data-id="element-166">
                  <div className="flex items-start justify-between gap-2" data-id="element-167">
                    <div data-id="element-168">
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-0.5" data-id="element-169">
                        Bono 03
                      </p>
                      <p className="text-sm font-semibold text-stone-900 leading-snug" data-id="element-170">
                        Kit Solución de Problemas
                      </p>
                      <p className="text-xs text-stone-500 mt-1" data-id="element-171">
                        Identifica la falla y aplica el fix correcto en minutos.
                      </p>
                    </div>
                    <span className="text-xs font-bold text-stone-400 line-through whitespace-nowrap flex-shrink-0" data-id="element-172">
                      $17
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between py-3 border-t border-stone-200 mb-3" data-id="element-173">
                <span className="text-xs text-stone-500 font-medium" data-id="element-174">
                  Valor total de bonos
                </span>
                <div className="text-right" data-id="element-175">
                  <span className="text-xs text-stone-400 line-through mr-1" data-id="element-176">
                    $37
                  </span>
                  <span className="text-xs font-bold text-green-600" data-id="element-177">
                    Gratis hoy
                  </span>
                </div>
              </div>

              <button onClick={() => setShowBonusDetail(!showBonusDetail)} className="flex items-center gap-1 text-xs text-amber-700 font-semibold hover:text-amber-900 transition-colors mb-1" data-id="element-178">
                {showBonusDetail ? <>
                    Ver menos <ChevronUp className="w-3.5 h-3.5" data-id="element-179" />
                  </> : <>
                    Leer más sobre los bonos{' '}
                    <ChevronDown className="w-3.5 h-3.5" data-id="element-180" />
                  </>}
              </button>

              {showBonusDetail && <div className="mt-3 space-y-4 border-t border-stone-200 pt-4" data-id="element-181">
                  {bonusDetails.map(bonus => <div key={bonus.number} className="bg-white rounded-lg p-4 border border-stone-200" data-id="element-182">
                      <div className="flex items-start justify-between mb-2" data-id="element-183">
                        <span className="text-xs font-bold text-stone-400 tracking-widest uppercase" data-id="element-184">
                          Bono {bonus.number}
                        </span>
                        <span className="text-xs font-semibold text-stone-500 bg-stone-100 px-2 py-0.5 rounded-full" data-id="element-185">
                          Valor: {bonus.value}
                        </span>
                      </div>
                      <h4 className="font-serif font-bold text-stone-900 text-sm leading-snug mb-0.5" data-id="element-186">
                        {bonus.title}
                      </h4>
                      <p className="text-xs text-amber-700 font-medium mb-2" data-id="element-187">
                        {bonus.subtitle}
                      </p>
                      <p className="text-xs text-stone-600 leading-relaxed mb-3 border-l-2 border-amber-300 pl-2" data-id="element-188">
                        {bonus.promise}
                      </p>
                      <ul className="space-y-1.5" data-id="element-189">
                        {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-xs text-stone-700" data-id="element-190">
                            <Check className="w-3.5 h-3.5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-191" />
                            {bullet}
                          </li>)}
                      </ul>
                    </div>)}
                </div>}
            </div>

            <div data-id="element-192">
              <div className="mb-8" data-id="element-193">
                <span className="text-stone-500 text-lg line-through decoration-red-500 decoration-2" data-id="element-194">
                  $97 USD
                </span>
                <div className="flex items-baseline gap-2" data-id="element-195">
                  <span className="text-5xl font-bold text-stone-900" data-id="element-196">
                    $6.39
                  </span>
                  <span className="text-xl text-stone-600 font-medium" data-id="element-197">
                    USD
                  </span>
                </div>
                <div className="mt-2 inline-flex items-center gap-1 text-green-600 bg-green-50 px-2 py-1 rounded text-sm font-bold" data-id="element-198">
                  Ahorras 90% hoy
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-199">
                <li className="flex items-start gap-3" data-id="element-200">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-201" />
                  <span className="text-stone-700" data-id="element-202">
                    <strong data-id="element-203">Guía Maestra Mil Hojas Pro</strong> (PDF Digital)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-204">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-205" />
                  <span className="text-stone-700" data-id="element-206">
                    <strong data-id="element-207">Lista de Marcas en EE.UU.</strong> (Walmart, Target,
                    etc)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-208">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-209" />
                  <span className="text-stone-700" data-id="element-210">
                    <strong data-id="element-211">Checklist de Emergencia</strong> para Humedad Alta
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-212">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-213" />
                  <span className="text-stone-700" data-id="element-214">
                    Acceso Inmediato y de por vida
                  </span>
                </li>
              </ul>

              <Button size="lg" fullWidth className="text-lg mb-3" onClick={() => {
              trackAddToCart();
              window.open('https://novadigitalventures.com/cart/42538050125895:1', '_blank');
            }} data-id="element-215">
                Obtener la Guía Maestra - $6.39
              </Button>

              <p className="text-center text-xs text-amber-700 font-medium mb-3" data-id="element-216">
                Compra hoy y desbloquea los Bonos SOLO HOY.
              </p>

              <div className="flex items-center justify-center gap-2 text-xs text-stone-500" data-id="element-217">
                <Shield className="w-3 h-3" data-id="element-218" />
                Pago 100% Seguro y Encriptado
              </div>

              <div className="mt-6 flex items-center gap-3 bg-stone-50 rounded-xl p-4 border border-stone-100" data-id="element-219">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-220">
                  <Shield className="w-5 h-5 text-amber-600" data-id="element-221" />
                </div>
                <div data-id="element-222">
                  <p className="font-bold text-stone-900 text-sm" data-id="element-223">
                    Garantía de Hierro
                  </p>
                  <p className="text-xs text-stone-500" data-id="element-224">
                    Si tu Mil Hojas no cruje, te devuelvo tu dinero. Sin
                    preguntas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}